export default __webpack_public_path__ + "static/media/image6.28431e17.png";